import { SupplierSubscriptionPlanMessage } from '../../../supplier-subscription-plans/types/SupplierSubscriptionPlanMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export interface GetSupplierSubscriptionPlansResponse {
    plans: SupplierSubscriptionPlanMessage[];
}

export const getSupplierSubscriptionPlans = async (): Promise<GetSupplierSubscriptionPlansResponse> => {
    const response = await authorizedAxiosInstance.get<GetSupplierSubscriptionPlansResponse>(
        '/v1/supplier-subscription-plans'
    );
    return response.data;
};
